export default function ErrorMsgComponent(props) {
	return <p className="text-red-800 border-red-300 bg-red-50 mt-4 px-4 py-2 rounded-md">{props.errMsg}</p>;
}
